import { Modal, Pagination, Spin } from 'antd';
import { formatPhone } from 'utils/formatPhone';
import { ICallerCallItem, ICallerHistoryEntry } from '../types';
import { callerDisplayName } from '../mappers';
import userIcon from '../icons/user.svg';
import {
  ModalBody,
  HeaderBar,
  HeaderTitle,
  HeaderClose,
  CustomerRow,
  Avatar,
  CusName,
  CusMeta,
  TableWrap,
  Table,
  HeadRow,
  HeadCell,
  BodyRow,
  Cell,
  ServicesCell,
  ActionCell,
  RebookBtn,
  FooterBar,
  PagerRow,
  LoadingWrap,
} from './booking-history-styles';

type Props = {
  open: boolean;
  item: ICallerCallItem;
  history: ICallerHistoryEntry[];
  total: number;
  page: number;
  pageSize: number;
  loading: boolean;
  onPageChange: (page: number) => void;
  onClose: () => void;
  onRebook: (entry: ICallerHistoryEntry) => void;
  rebookDisabled?: boolean; // true while a staff-availability check is running
};

// TOTAL stays out — the customer-appointments API doesn't provide it.
const COLUMNS = ['DATE', 'TIME', 'STAFF', 'SERVICES', 'ACTION'];

// Full booking-history table opened from the HISTORY section's "See more".
const BookingHistoryModal = ({ open, item, history, total, page, pageSize, loading, onPageChange, onClose, onRebook, rebookDisabled }: Props) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    title={null}
    closable={false}
    closeIcon={null}
    width={920}
    centered
    styles={{ content: { padding: 0, borderRadius: 14, overflow: 'hidden' }, body: { padding: 0 } }}
  >
    <ModalBody>
      <HeaderBar>
        <HeaderTitle>BOOKING HISTORY</HeaderTitle>
        <HeaderClose type="button" onClick={onClose}>
          CLOSE
        </HeaderClose>
      </HeaderBar>

      <CustomerRow>
        <Avatar>
          <img src={userIcon} alt="" />
        </Avatar>
        <CusName>{callerDisplayName(item)}</CusName>
        <CusMeta>{`· ${formatPhone(item.phone)}`}</CusMeta>
        <CusMeta>{`· ${total} booking${total === 1 ? '' : 's'}`}</CusMeta>
      </CustomerRow>

      <TableWrap>
        <Table>
          <HeadRow>
            {COLUMNS.map((c) => (
              <HeadCell key={c}>{c}</HeadCell>
            ))}
          </HeadRow>
          {history.map((entry, i) => (
            <BodyRow key={`${entry.date}-${i}`}>
              <Cell>{entry.date}</Cell>
              <Cell>{entry.time}</Cell>
              {/* Missing name = the staff was deleted; the row still needs a filled cell. */}
              <Cell>{entry.staff || '—'}</Cell>
              <ServicesCell>
                <span className="svc">{entry.services}</span>
                {entry.note && <span className="note">{entry.note}</span>}
              </ServicesCell>
              <ActionCell>
                <RebookBtn type="button" disabled={rebookDisabled} onClick={() => onRebook(entry)}>
                  Re Book
                </RebookBtn>
              </ActionCell>
            </BodyRow>
          ))}
        </Table>
        {loading && (
          <LoadingWrap>
            <Spin />
          </LoadingWrap>
        )}
      </TableWrap>

      {total > pageSize && (
        <PagerRow>
          <Pagination
            current={page}
            pageSize={pageSize}
            total={total}
            showSizeChanger={false}
            onChange={onPageChange}
          />
        </PagerRow>
      )}

      <FooterBar type="button" onClick={onClose}>
        CLOSE
      </FooterBar>
    </ModalBody>
  </Modal>
);

export default BookingHistoryModal;
